<template>
	<div class="container-fluid" :class="{'bg-white':whiteBgs.indexOf($route.params.tab) >= 0}">
		<toolbar>

			<div>
				<router-link v-if="'Users' in $store.userModulePerms && $store.userModulePerms.Users.read" to="/employees/list" class="btn btn-link">
					<i class="fa fa-caret-left fa-2x"></i>
					<h2>Employees</h2>
				</router-link>
			</div>

			<div class="controls">
				<nav-tabs :tabs="mutatedTabs" 
					v-on:tabClick="tabClick" 
					:active-index="activeTabIndex"
					:mobile-breakpoint="750">		
				</nav-tabs>
			</div>
		</toolbar>

		<alert 
			v-if="$store.employee && 'id' in $store.employee && 'UserPermission' in $store.employee && $store.employee.UserPermission.length > 0 && $store.employee.UserPermission[0].is_inactive == 1 && (getUserRoleType() == 'Admin' || hasModulePermWrite('Users'))"
			classes="alert-warning top-alert" 
			:message="$store.employee.first_name+ ' '+ $store.employee.last_name+ ' is no longer working at the company, ending on ' + formatDateTimeToLocal($store.employee.UserPermission[0].disconnect_date,'full-date') + '. His data is read only.'" 
			:unclosable="true" 
			icon="fa-archive"
			:visible="true"
			button-text="Reinstate"
			button-class="btn-primary"
			v-on:buttonClick="reinstateEmployee">
		</alert>

		<employee-details v-if="activeTab == 'profile'" :block-fetches="blockFetches"></employee-details>
		<employee-expenses v-else-if="activeTab == 'expenses'" :block-fetches="blockFetches"></employee-expenses>
		<employee-time-logs v-else-if="activeTab == 'time-logs'" :block-fetches="blockFetches"></employee-time-logs>
		<employee-certificates v-else-if="activeTab == 'certificates'" :block-fetches="blockFetches"></employee-certificates>
		
		<employee-library-acknowledgements v-else-if="activeTab == 'library-acknowledgements'" :block-fetches="blockFetches"></employee-library-acknowledgements>

		<employment-settings v-else-if="activeTab == 'employment-settings'" :block-fetches="blockFetches"></employment-settings>

		<employee-permissions v-else-if="activeTab == 'permissions'"></employee-permissions>

		<account-settings v-else-if="activeTab == 'account-settings'"></account-settings>

		<employee-events v-else-if="activeTab == 'calendar-events'"></employee-events>

		<employee-forms v-else-if="activeTab == 'forms'"></employee-forms>


	</div>
</template>

<script>
import EmployeeDetails from "./employees/employee_tabs/EmployeeDetails"
import EmployeeExpenses from "./employees/employee_tabs/EmployeeExpenses"
import EmployeeTimeLogs from "./employees/employee_tabs/EmployeeTimeLogs"
import EmployeeCertificates from "./employees/employee_tabs/EmployeeCertificates"
import EmployeePermissions from "./employees/employee_tabs/EmployeePermissions"
import EmploymentSettings from "./employees/employee_tabs/EmploymentSettings"
import AccountSettings from "./employees/employee_tabs/AccountSettings"
import EmployeeLibraryAcknowledgements from "./employees/employee_tabs/EmployeeLibraryAcknowledgements"
import EmployeeEvents from "./employees/employee_tabs/EmployeeEvents"
import EmployeeForms from "./employees/employee_tabs/EmployeeForms"

import Alert from "@/components/Alert"

import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"

export default {

	name: 'Employee',
	components: {
		EmployeeDetails,
		EmployeeExpenses,
		EmployeePermissions,
		EmployeeTimeLogs,
		EmploymentSettings,
		EmployeeCertificates,
		EmployeeLibraryAcknowledgements,
		EmployeeEvents,
		EmployeeForms,
		AccountSettings,
		Toolbar,
		NavTabs,
		Alert
	},
	data() {
		return {
			whiteBgs: ["expenses","time-logs","library-acknowledgements"],
			blockFetches: true,
			activeTab: this.$route.params.tab,
			tabs: [
				{
					label: "Profile",
					icon: "fa-user-circle",
					tab: "profile",
					freemiumTier: true
				},
				{
					label: "Certificates",
					icon: "fa-id-card",
					tab: "certificates",
					modulePermRequired: ["Certificates"],
					allowedIfOwn: true
				},
				{
					label: "Time Logs",
					icon: "fa-clock",
					tab: "time-logs",
					modulePermRequired: ["TimeLogs"],
					allowedIfOwn: true,
					freemiumTier: true
				},
				{
					label: "Expenses",
					icon: "fa-receipt",
					tab: "expenses",
					modulePermRequired: ["Expenses"],
					allowedIfOwn: true
				},
				{
					label: "Forms",
					icon: "fa-clipboard-check",
					tab: "forms",
					modulePermRequired: ["Users","Company Forms"],
					allowedIfOwn: true
				},
				{
					label: "Employment Settings",
					icon: "fa-cog",
					tab: "employment-settings",
					modulePermRequired: ["Users"],
					more: true,
					freemiumTier: true
				},
				{
					label: "Permissions",
					icon: "fa-lock",
					tab: "permissions",
					adminRequired: true,
					mustBeActive: true,
					more: true,
					freemiumTier: true
				},
				{
					label: "Account Settings",
					icon: "fa-cog",
					tab: "account-settings",
					modulePermRequired: ["Users"],
					mustBeActive: true,
					allowedIfOwn: true,
					more: true,
					freemiumTier: true
				},
				{
					label: "Calendar Events",
					icon: "fa-calendar",
					tab: "calendar-events",
					modulePermRequired: ["Users"],
					allowedIfOwn: true,
					more: true
				},
				{
					label: "Library Activity",
					icon: "fa-check-square",
					tab: "library-acknowledgements",
					modulePermRequired: ["Users","Library"],
					allowedIfOwn: true,
					more: true
				}
			]
		}
	},
	computed: {
		activeTabIndex() {
			return this.mutatedTabs.findIndex(tab => tab.tab == this.activeTab)
		},
		isInactive() {
			if (this.$store.employee && "UserPermission" in this.$store.employee && this.$store.employee.UserPermission.length > 0 && this.$store.employee.UserPermission[0].is_inactive == 1)
				return true;
			else
				return false
		},
		mutatedTabs() {
			let vm = this

			let tabs = this.tabs.map(item => {
				item.linkPath = "/employee/"+this.$route.params.id+"/"+item.tab
				item.link = "/employee/"+this.$route.params.id+"/"+item.tab

				item.click = item.tab

				return item
			})

			//filter tabs to remove permissions tab if user is looking at own account
			tabs = tabs.map(item => {

				if ("allowedIfOwn" in item && item.allowedIfOwn) {
					if (vm.$store.userDetails.slug == vm.$route.params.id) {
						delete item.modulePermRequired

						return item
					}
				}
				return item

			}).filter(item => {
				//check to make sure permssions tab isn't shown on user's own self
				if (item.tab == "permissions" && vm.$store.userDetails.slug == vm.$route.params.id) {
					return false
				}

				if (!this.hasActiveEmployer()) {
					//tabs that should show when employee is disconnected from a company
					let disconnectedTabList = [
						"profile",
						"account-settings"
					]

					if (disconnectedTabList.indexOf(item.tab) == -1)
						return false
				}

				if (vm.isInactive && "mustBeActive" in item && item.mustBeActive)
					return false

				//only show account-settings tab on own profile, or if user is Admin, or has Users module write perm
				else if (item.tab == "account-settings") {

					if (vm.$store.userDetails.slug == vm.$route.params.id || vm.$store.userRole == "Admin" || vm.$store.userModulePerms.Users.write) 
						return true
					else
						return false
				}
				else
					return true
			})

			return this.filterNavForPerms(tabs)
		}
	},
	methods: {
		tabClick(tab) {
			this.activeTab = tab

			let tabObj = this.mutatedTabs.find(tabListTab => tabListTab.tab == tab)

			if (tabObj) {
				//window.history.pushState({},"",tabObj.linkPath)
				this.$router.push(tabObj.linkPath)
			}
		},
		reinstateEmployee() {
			let vm = this

			let payload = {
				id: vm.$store.employee.UserPermission[0].id,
				is_inactive: 0,
				disconnect_date: null
			}

			this.postData("UserPermission/save",payload,true).then(response => {
				vm.fetchEmployee()
			})
		},
		fetchEmployee() {
			let vm = this

			let params = {
				include: [
					"ProfileImage",
					"UserPermission",
					"EmployeeClassification",
					"EmployeeSetting"
				]
			}

			this.getJSON("User/find/"+this.$route.params.id,params,true).then(function(response){

				if (response.success) {
					vm.$set(vm.$store,"employee",response.data)

					//fetch union now
					if (vm.$store.employee && "EmployeeClassification" in vm.$store.employee && vm.$store.employee.EmployeeClassification.length > 0) {

						vm.getJSON("Union/find/"+vm.$store.employee.EmployeeClassification[0].union_id).then(response => {
							vm.spinner(false)
							if (response.success)
								vm.$set(vm.$store.employee,"Union",response.data)

						})
					}
					else
						vm.spinner(false)

					if (response.data.ProfileImage) {
						vm.$store.profileImage = response.data.ProfileImage
						vm.$store.profileImageUrl = vm.$root.apiRoot+'resources/profile-images/'+response.data.ProfileImage.slug+'/'+response.data.ProfileImage.filename
					}

					vm.blockFetches = false
				}
				
			})
		}
	},
	created() {
		//this.$store.employee = {ProfileImage: {}}

		//check if this is user's employee account, if so, give them a list of the companies they have worked at
		/*if (this.$route.params.id == this.$store.userSlug) {
			this.tabs.unshift({	
				label: "Companies",
				icon: "fa-building-o",
				tab: "companies",
				adminRequired: true	
			})
		}*/

		let vm = this

		vm.$store.profileImageUrl = false
		vm.$store.profileImage = null

		this.activeTab = this.$route.params.tab

		if (!("slug" in this.$store.employee) || this.$store.employee.slug != this.$route.params.id || !this.$store.profileImage) {
			this.fetchEmployee();
		}
		else
			this.blockFetches = false
	}

}
</script>